// Example class
let _this = (module.exports = {
  // Set the dom elements
  dom: {
    body: document.querySelector("body"),
  },

  // Set variables
  vars: {
    flag: false,
  },

  menu: function () {
    const menu = document.querySelectorAll(".menu-item");
    const homeLink = document.querySelectorAll('a[aria-current="page"]');
    const logo = document.querySelector(".logo");

    homeLink.forEach((home) => {
      home.addEventListener("click", (e) => {
        e.preventDefault();

        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    });

    logo.addEventListener("click", (e) => {
      e.preventDefault();

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });

    if (!menu) return;

    menu.forEach((item) => {
      item.addEventListener("click", () => {
        const link = item.querySelector("a");

        menu.forEach((el) => el.classList.remove("current-menu-item"));

        item.classList.add("current-menu-item");
      });
    });
  },

  /**
   * Init functions
   */
  init: function () {
    this.menu();
  },
});
